import "../PageCommon.css";
import "./Settings.css";

const SettingsPage = () => {
  return (
    <div className="page__container">
      <div className="page__body">
        <div className="page__label">
          <h2>Settings</h2>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;